import {Component, OnDestroy, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {Modulo, modulosActivos} from "./Modulo-Externo";
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { environment } from '../../environments/environment';
import {GroupsMSGraph, ResponseMSGraph} from "../graphInterface/GraphInterfaces";
import {FuncionesExterno} from "../externo/funciones-Externo";

@Component({
  selector: 'ral-hub',
  templateUrl: './hub-externo.component.html',
  styleUrls: ['./hub-externo.component.scss']
})

export class HubExternoComponent implements OnInit, OnDestroy {
  modulos: Modulo[] = [];

  constructor(private router: Router, private http: HttpClient){

  }

  ngOnInit() {
    this.getAccessTokenAndCallGraphAPI();
    document.body.style.background = "#e2ede7";

  }

  getAccessTokenAndCallGraphAPI(){
    var token = FuncionesExterno.getToken();
    if (!token){
      this.router.navigate(["/externo"]);
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + token)}

    //Control this error
    //{"error":{"code":"InvalidAuthenticationToken","message":"Lifetime validation failed, the token is expired.","innerError":{"date":"2024-09-16T11:55:00","request-id":"3e876abb-d2df-49df-8d5b-2897bb6e3245","client-request-id":"3e876abb-d2df-49df-8d5b-2897bb6e3245"}}}
    this.http.get("https://graph.microsoft.com/v1.0/me/memberOf?$select=id,mail", httpOptions).subscribe({
      next: (result) => {
        var gruposUsuario: ResponseMSGraph = JSON.parse(JSON.stringify(result));
        this.getGroupsHubPermissions(gruposUsuario, token!);
      },
      error: (error) => {

        if (error.error && error.error.error.code === "InvalidAuthenticationToken" && error.error.error.message.includes("token is expired")) {
          this.router.navigate(["/externo"]);
        } else {
          alert("Error al autenticar al usuario. Por favor, intente nuevamente.")
        }
      }
    });

  }

  getGroupsHubPermissions(userGroups: ResponseMSGraph, token:string){
    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);
    options = options.set('Access-Control-Allow-Credentials', 'true');

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }
    let gruposUsuarioArray = "[";
    for (let i = 0; i < userGroups.value.length; i++) {
      let grupo: GroupsMSGraph = userGroups.value[i];
      gruposUsuarioArray += "\"" + grupo.id.toString() + "\",";
    }
     gruposUsuarioArray = gruposUsuarioArray.substring(0, gruposUsuarioArray.length-1) + "]";

    FuncionesExterno.getDataUser(token, this.http).then(user => {
      let postData = "{\"userId\":\"" + user!.id + "\",\"grupoIds\":" + gruposUsuarioArray + "}";
      this.http.post(environment.azureWSBase + "/Groups/hubGroups", postData, httpOptions).subscribe(result => {
        let jsonRespuesta = JSON.parse(result.toString());
        for (let i = 0; i < jsonRespuesta["response"].length; i++) {
          let modulName = jsonRespuesta["response"][i];
          let nuevoModulo: Modulo = modulosActivos[modulName];
          this.modulos.push(nuevoModulo);
        }

        if (this.modulos.length === 1){
            this.router.navigate([this.modulos[0].url]);
        }

        document.getElementById("contenedor-carga")!.className = "ocultar";
      });
    });
  }

  logout() {
    FuncionesExterno.logout();
  }

  ngOnDestroy(){
    document.body.style.background = "";
  }

}
